import { useState } from "react";
import { setDoc, doc } from "firebase/firestore";
import { db } from "../../../firebase/config";
import { Athlete } from "../../../types";

export default function AthleteForm() {
  const [formData, setFormData] = useState<Athlete>({
    firstName: "",
    lastName: "",
    birthday: "",
    gender: "",
    email: "",
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await setDoc(doc(db, "athletes", formData.email), formData);
    alert("Athlete saved!");
    setFormData({
      firstName: "",
      lastName: "",
      birthday: "",
      gender: "",
      email: "",
    });
  };

  const handleAddAll = async () => {
    const response = await fetch("/backup-users.json");
    const data = await response.json();
    for (const user of data) {
      const athlete = {
        firstName: user.firstName,
        lastName: user.lastName,
        birthday: user.dob,
        gender: user.gender,
        email: user.email,
      };
      await setDoc(doc(db, "athletes", user.email), athlete);
    }
    alert("All athletes imported!");
  };

  return (
    <form className="admin-form" onSubmit={handleSubmit}>
      <input
        name="firstName"
        placeholder="First Name"
        value={formData.firstName}
        onChange={handleChange}
        required
      />
      <input
        name="lastName"
        placeholder="Last Name"
        value={formData.lastName}
        onChange={handleChange}
        required
      />
      <input
        name="birthday"
        type="date"
        value={formData.birthday}
        onChange={handleChange}
        required
      />
      <select
        name="gender"
        value={formData.gender}
        onChange={handleChange}
        required
      >
        <option value="">Select Gender</option>
        <option>Male</option>
        <option>Female</option>
        <option>Other</option>
      </select>
      <input
        name="email"
        type="email"
        placeholder="Email"
        value={formData.email}
        onChange={handleChange}
        required
      />
      <button type="submit">Save Athlete</button>
      {/* <button type="button" onClick={handleAddAll}>
        Add All
      </button> */}
    </form>
  );
}
